import './PlanBenefitTile.scss';

import { isDefaultBrand, useConfig } from '@travelwin/core';
import { ReactNode, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import {
  getPlanBenefitDetails,
  PlanBenefitTypesKeys,
} from './planBenefitTypes';

interface Props {
  type: PlanBenefitTypesKeys;
  value: ReactNode;
}

const className = 'c-PlanBenefitTile';

const PlanBenefitTile = ({ type, value }: Props) => {
  const { t } = useTranslation();
  const { WHITELABEL_BRAND } = useConfig();
  const benefitDetails = useMemo(
    () => getPlanBenefitDetails(t, isDefaultBrand(WHITELABEL_BRAND)),
    [t, WHITELABEL_BRAND],
  );

  return (
    <div className={className}>
      <div className={`${className}__label`}>
        <div className={`${className}__icon`}>{benefitDetails[type].icon}</div>
        <div className={`${className}__text`}>
          <span>{benefitDetails[type].label}</span>
        </div>
      </div>
      <div className={`${className}__value`}>{value}</div>
    </div>
  );
};

export default PlanBenefitTile;
